// orion-web reports to Wix's org on the PUBLIC Sentry SaaS — https://wix-o.sentry.io — not the
// internal sentry.wixpress.com this pointed at during an earlier pass. This is the US-region ingest
// DSN for the orion-web project (org id o37417, project id 4511919392882688).
//
// A Sentry DSN is a public, browser-safe ingest key by design
// (https://docs.sentry.io/product/sentry-basics/dsn-explainer/), so — same reasoning as the ARTIFACT
// version below — it belongs in source control rather than a databag secret. Empty means Sentry.init
// is skipped everywhere (see instrumentation-client.ts / sentry.server.config.ts).
export const ORION_WEB_SENTRY_DSN =
  'https://80405d9a237266c9d942791a6b32bd4d@o37417.ingest.us.sentry.io/4511919392882688';

// The org + project slug the withSentryConfig webpack plugin references (see next.config.js).
// These are only consulted for a build-time source-map UPLOAD — which we do not perform: on Sentry
// cloud, symbolication comes from Sentry fetching the public `.map` off the CDN, so no upload and no
// auth token (see the comments in next.config.js). Event ingest uses the numeric project id baked
// into the DSN above, so these slugs being exactly right does not affect anything today; they matter
// only for a one-off local `SENTRY_AUTH_TOKEN=… next build`.
export const ORION_WEB_SENTRY_ORG = 'wix-o';
export const ORION_WEB_SENTRY_PROJECT = 'orion-web';
